import { render, staticRenderFns } from "./LmQmsTotems.vue?vue&type=template&id=3ff1893c&scoped=true&"
import script from "./LmQmsTotems.vue?vue&type=script&lang=js&"
export * from "./LmQmsTotems.vue?vue&type=script&lang=js&"
import style0 from "./LmQmsTotems.vue?vue&type=style&index=0&id=3ff1893c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff1893c",
  null
  
)

export default component.exports